
import {Box, FormHelperText} from '@mui/material';
import React from "react";
import CustomAddChipSearch from "../../../../../../../components/CustomAddChipSearch";
import {deviceListToLabel} from "../../../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../../../components/buttons/IconButtons";
import {CustomTextField} from "../../../../../../../components/CustomTextField";
import DividerWithText from "../../../../../../../components/DividerWithText";
import {CustomStyleFormHelperText} from "../../../../../../../components/Styles";
import {TABLES} from "../../../../../../../Apis/Tables";
import CustomRadio from "../../../../../../../components/CustomRadio";
/**
 * @Email : azpaata@ibl.mx
 * @Author: Arnulfo Ferro Zapata
 * @jobTittle: developer
 */
const DetailsStep = ({ disabled, handleChange, emptyFields, item, selectedList, setSelectedList,t,setItem }) => {
    const isValidRestriction = (item.morning === true || item.warning === true || item.restricted === true)

    return (
        <>
            <Box className='col-12'>
                <CustomTextField
                    id='txt_ds_name'
                    name='name'
                    trans='name'
                    required={true}
                    onChange={handleChange}
                    value={item?.name}
                    emptyFields={emptyFields}
                    disabled={disabled}
                />
            </Box>
            <Box className='col-12'>
                <CustomTextField
                    id='txt_ds_description'
                    name='description'
                    value={item?.description}
                    trans='description'
                    onChange={handleChange}
                    length={512}
                    required={true}
                    emptyFields={emptyFields}
                    multiline
                    rows={3}
                    disabled={disabled}
                />
            </Box>
            <div className={"col-12"}>
                <DividerWithText title={t('restrictions')} />
            </div>

            <Box className="col-12">
                <CustomRadio
                    id="rbtn_ds_morning_only"
                    trans="morning_only_none"
                    name="morning"
                    value="true"
                    checked={item?.morning === true}
                    onChange={(e) => {
                        handleChange(e);
                        setItem(prev => ({ ...prev, warning: false, restricted: false }));
                    }}
                    labelClassName="fs-14px font-color-general-950"
                    disabled={disabled}
                />
            </Box>

            <Box className="col-12">
                <CustomRadio
                    id="rbtn_ds_warning_mode_soft"
                    trans="warning_mode_soft"
                    name="warning"
                    value="true"
                    checked={item?.warning === true}
                    onChange={(e) => {
                        handleChange(e);
                        setItem(prev => ({ ...prev, morning: false, restricted: false }));
                    }}
                    labelClassName="fs-14px font-color-general-950"
                    disabled={disabled}
                />
            </Box>

            <Box className="col-12">
                <CustomRadio
                    id="rbtn_ds_restricted_access_hard"
                    trans="restricted_access_hard"
                    name="restricted"
                    value="true"
                    checked={item?.restricted === true}
                    onChange={(e) => {
                        handleChange(e);
                        setItem(prev => ({ ...prev, morning: false, warning: false }));
                    }}
                    labelClassName="fs-14px font-color-general-950"
                    disabled={disabled}
                />
            </Box>

            <div className={"col-12"}>
                <FormHelperText error={true} sx={CustomStyleFormHelperText(false)}>
                    {emptyFields && !isValidRestriction && t('select_one_option')}
                </FormHelperText>
            </div>
            <div className={"col-12 mb-2"}>
                <DividerWithText title={t('scope')} />
            </div>
            <div className={"row"}>
                <div className={"col-12 mb-3"}>
                    <p className={"fs-14px ibl-font-w-600 font-color-shades-950"}>{t('devices')}</p>
                </div>
                <div className={"col-12 col-lg-4"}>
                    <p className={"d-flex h-44px align-items-center fs-14px ibl-font-w-400 font-color-shades-950"}>{t('configure_which_devices')}</p>
                </div>
                <div className={"col-12 col-lg-8 mb-5"}>
                    <CustomAddChipSearch
                        autocompleteId={'slt_ds_devices'}
                        buttonId={'btn_ds_add_device'}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        disabled={false}
                        label="devices"
                        emptyFields={emptyFields}
                        required={true}
                        reset={false}
                        hideButton={false}
                        keyId={"id"}
                        showSubSection={true}
                        sanitizeDataList={deviceListToLabel}
                        showRenderOption={true}
                        Icon={PersonChipBlack}
                        chipIcon={null}
                        model={TABLES.DEVICES}
                    />
                </div>
            </div>

        </>
    );
};

export default DetailsStep;
